/* tslint:disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum Country {
  AFGHANISTAN = "AFGHANISTAN",
  ALAND_ISLANDS = "ALAND_ISLANDS",
  ALBANIA = "ALBANIA",
  ALGERIA = "ALGERIA",
  AMERICAN_SAMOA = "AMERICAN_SAMOA",
  ANDORRA = "ANDORRA",
  ANGOLA = "ANGOLA",
  ANGUILLA = "ANGUILLA",
  ANTARCTICA = "ANTARCTICA",
  ANTIGUA_AND_BARBUDA = "ANTIGUA_AND_BARBUDA",
  ARGENTINA = "ARGENTINA",
  ARMENIA = "ARMENIA",
  ARUBA = "ARUBA",
  ASCENSION_ISLAND = "ASCENSION_ISLAND",
  AUSTRALIA = "AUSTRALIA",
  AUSTRIA = "AUSTRIA",
  AZERBAIJAN = "AZERBAIJAN",
  BAHAMAS = "BAHAMAS",
  BAHRAIN = "BAHRAIN",
  BANGLADESH = "BANGLADESH",
  BARBADOS = "BARBADOS",
  BELARUS = "BELARUS",
  BELGIUM = "BELGIUM",
  BELIZE = "BELIZE",
  BENIN = "BENIN",
  BERMUDA = "BERMUDA",
  BHUTAN = "BHUTAN",
  BOLIVIA_PLURINATIONAL_STATE_OF = "BOLIVIA_PLURINATIONAL_STATE_OF",
  BONAIRE_SAINT_EUSTATIUS_AND_SABA = "BONAIRE_SAINT_EUSTATIUS_AND_SABA",
  BOSNIA_AND_HERZEGOVINA = "BOSNIA_AND_HERZEGOVINA",
  BOTSWANA = "BOTSWANA",
  BOUVET_ISLAND = "BOUVET_ISLAND",
  BRAZIL = "BRAZIL",
  BRITISH_ANTARCTIC_TERRITORY = "BRITISH_ANTARCTIC_TERRITORY",
  BRITISH_INDIAN_OCEAN_TERRITORY = "BRITISH_INDIAN_OCEAN_TERRITORY",
  BRUNEI_DARUSSALAM = "BRUNEI_DARUSSALAM",
  BULGARIA = "BULGARIA",
  BURKINA_FASO = "BURKINA_FASO",
  BURMA = "BURMA",
  BURUNDI = "BURUNDI",
  BYELORUSSIAN_SSR = "BYELORUSSIAN_SSR",
  CABO_VERDE = "CABO_VERDE",
  CAMBODIA = "CAMBODIA",
  CAMEROON = "CAMEROON",
  CANADA = "CANADA",
  CANARY_ISLANDS = "CANARY_ISLANDS",
  CANTON_AND_ENDERBURY_ISLANDS = "CANTON_AND_ENDERBURY_ISLANDS",
  CAYMAN_ISLANDS = "CAYMAN_ISLANDS",
  CENTRAL_AFRICAN_REPUBLIC = "CENTRAL_AFRICAN_REPUBLIC",
  CEUTA_MULILLA = "CEUTA_MULILLA",
  CHAD = "CHAD",
  CHILE = "CHILE",
  CHINA = "CHINA",
  CHRISTMAS_ISLAND = "CHRISTMAS_ISLAND",
  CLIPPERTON_ISLAND = "CLIPPERTON_ISLAND",
  COCOS_KEELING_ISLANDS = "COCOS_KEELING_ISLANDS",
  COLOMBIA = "COLOMBIA",
  COMOROS = "COMOROS",
  COOK_ISLANDS = "COOK_ISLANDS",
  COSTA_RICA = "COSTA_RICA",
  COTE_DIVOIRE = "COTE_DIVOIRE",
  CROATIA = "CROATIA",
  CUBA = "CUBA",
  CURACAO = "CURACAO",
  CYPRUS = "CYPRUS",
  CZECHOSLOVAKIA = "CZECHOSLOVAKIA",
  CZECH_REPUBLIC = "CZECH_REPUBLIC",
  DAHOMEY = "DAHOMEY",
  DEMOCRATIC_REPUBLIC_OF_CONGO = "DEMOCRATIC_REPUBLIC_OF_CONGO",
  DENMARK = "DENMARK",
  DIEGO_GARCIA = "DIEGO_GARCIA",
  DJIBOUTI = "DJIBOUTI",
  DOMINICA = "DOMINICA",
  DOMINICAN_REPUBLIC = "DOMINICAN_REPUBLIC",
  DRONNING_MAUD_LAND = "DRONNING_MAUD_LAND",
  EAST_TIMOR = "EAST_TIMOR",
  ECUADOR = "ECUADOR",
  EGYPT = "EGYPT",
  EL_SALVADOR = "EL_SALVADOR",
  EQUATORIAL_GUINEA = "EQUATORIAL_GUINEA",
  ERITREA = "ERITREA",
  ESTONIA = "ESTONIA",
  ETHIOPIA = "ETHIOPIA",
  EUROPEAN_UNION = "EUROPEAN_UNION",
  FALKLAND_ISLANDS = "FALKLAND_ISLANDS",
  FAROE_ISLANDS = "FAROE_ISLANDS",
  FIJI = "FIJI",
  FINLAND = "FINLAND",
  FRANCE = "FRANCE",
  FRANCE_METROPOLITAN = "FRANCE_METROPOLITAN",
  FRENCH_AFAR_AND_ISSAS = "FRENCH_AFAR_AND_ISSAS",
  FRENCH_GUIANA = "FRENCH_GUIANA",
  FRENCH_POLYNESIA = "FRENCH_POLYNESIA",
  FRENCH_SOUTHERN_AND_ANTARCTIC_TERRITORIES = "FRENCH_SOUTHERN_AND_ANTARCTIC_TERRITORIES",
  FRENCH_SOUTHERN_TERRITORIES = "FRENCH_SOUTHERN_TERRITORIES",
  GABON = "GABON",
  GAMBIA = "GAMBIA",
  GEORGIA = "GEORGIA",
  GERMANY = "GERMANY",
  GERMAN_DEMOCRATIC_REPUBLIC = "GERMAN_DEMOCRATIC_REPUBLIC",
  GHANA = "GHANA",
  GIBRALTAR = "GIBRALTAR",
  GILBERT_AND_ELLICE_ISLANDS = "GILBERT_AND_ELLICE_ISLANDS",
  GREECE = "GREECE",
  GREENLAND = "GREENLAND",
  GRENADA = "GRENADA",
  GUADELOUPE = "GUADELOUPE",
  GUAM = "GUAM",
  GUATEMALA = "GUATEMALA",
  GUERNSEY = "GUERNSEY",
  GUINEA = "GUINEA",
  GUINEA_BISSAU = "GUINEA_BISSAU",
  GUYANA = "GUYANA",
  HAITI = "HAITI",
  HEARD_ISLAND_AND_MCDONALD_ISLANDS = "HEARD_ISLAND_AND_MCDONALD_ISLANDS",
  HONDURAS = "HONDURAS",
  HONG_KONG = "HONG_KONG",
  HUNGARY = "HUNGARY",
  ICELAND = "ICELAND",
  INDIA = "INDIA",
  INDONESIA = "INDONESIA",
  IRAN_ISLAMIC_REPUBLIC_OF = "IRAN_ISLAMIC_REPUBLIC_OF",
  IRAQ = "IRAQ",
  IRELAND = "IRELAND",
  ISLE_OF_MAN = "ISLE_OF_MAN",
  ISRAEL = "ISRAEL",
  ITALY = "ITALY",
  JAMAICA = "JAMAICA",
  JAPAN = "JAPAN",
  JERSEY = "JERSEY",
  JOHNSTON_ISLAND = "JOHNSTON_ISLAND",
  JORDAN = "JORDAN",
  KAZAKHSTAN = "KAZAKHSTAN",
  KENYA = "KENYA",
  KIRIBATI = "KIRIBATI",
  KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF = "KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF",
  KOREA_REPUBLIC_OF = "KOREA_REPUBLIC_OF",
  KOSOVO = "KOSOVO",
  KUWAIT = "KUWAIT",
  KYRGYZSTAN = "KYRGYZSTAN",
  LAO_PEOPLES_DEMOCRATIC_REPUBLIC = "LAO_PEOPLES_DEMOCRATIC_REPUBLIC",
  LATVIA = "LATVIA",
  LEBANON = "LEBANON",
  LESOTHO = "LESOTHO",
  LIBERIA = "LIBERIA",
  LIBYA = "LIBYA",
  LIECHTENSTEIN = "LIECHTENSTEIN",
  LITHUANIA = "LITHUANIA",
  LUXEMBOURG = "LUXEMBOURG",
  MACAO = "MACAO",
  MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF = "MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF",
  MADAGASCAR = "MADAGASCAR",
  MALAWI = "MALAWI",
  MALAYSIA = "MALAYSIA",
  MALDIVES = "MALDIVES",
  MALI = "MALI",
  MALTA = "MALTA",
  MARSHALL_ISLANDS = "MARSHALL_ISLANDS",
  MARTINIQUE = "MARTINIQUE",
  MAURITANIA = "MAURITANIA",
  MAURITIUS = "MAURITIUS",
  MAYOTTE = "MAYOTTE",
  MEXICO = "MEXICO",
  MICRONESIA_FEDERATED_STATES_OF = "MICRONESIA_FEDERATED_STATES_OF",
  MIDWAY_ISLANDS = "MIDWAY_ISLANDS",
  MOLDOVA = "MOLDOVA",
  MONACO = "MONACO",
  MONGOLIA = "MONGOLIA",
  MONTENEGRO = "MONTENEGRO",
  MONTSERRAT = "MONTSERRAT",
  MOROCCO = "MOROCCO",
  MOZAMBIQUE = "MOZAMBIQUE",
  MYANMAR = "MYANMAR",
  NAMIBIA = "NAMIBIA",
  NAURU = "NAURU",
  NEPAL = "NEPAL",
  NETHERLANDS = "NETHERLANDS",
  NETHERLANDS_ANTILLES = "NETHERLANDS_ANTILLES",
  NEUTRAL_ZONE = "NEUTRAL_ZONE",
  NEW_CALEDONIA = "NEW_CALEDONIA",
  NEW_HEBRIDES = "NEW_HEBRIDES",
  NEW_ZEALAND = "NEW_ZEALAND",
  NICARAGUA = "NICARAGUA",
  NIGER = "NIGER",
  NIGERIA = "NIGERIA",
  NIUE = "NIUE",
  NORFOLK_ISLAND = "NORFOLK_ISLAND",
  NORTHERN_MARIANA_ISLANDS = "NORTHERN_MARIANA_ISLANDS",
  NORWAY = "NORWAY",
  OMAN = "OMAN",
  PACIFIC_ISLANDS_TRUST_TERRITORY_OF_THE = "PACIFIC_ISLANDS_TRUST_TERRITORY_OF_THE",
  PAKISTAN = "PAKISTAN",
  PALAU = "PALAU",
  PALESTINIAN_TERRITORY_OCCUPIED = "PALESTINIAN_TERRITORY_OCCUPIED",
  PANAMA = "PANAMA",
  PANAMA_CANAL_ZONE = "PANAMA_CANAL_ZONE",
  PAPUA_NEW_GUINEA = "PAPUA_NEW_GUINEA",
  PARAGUAY = "PARAGUAY",
  PERU = "PERU",
  PHILIPPINES = "PHILIPPINES",
  PITCAIRN = "PITCAIRN",
  POLAND = "POLAND",
  PORTUGAL = "PORTUGAL",
  PUERTO_RICO = "PUERTO_RICO",
  QATAR = "QATAR",
  REPUBLIC_OF_CONGO = "REPUBLIC_OF_CONGO",
  REUNION = "REUNION",
  ROMANIA = "ROMANIA",
  RUSSIAN_FEDERATION = "RUSSIAN_FEDERATION",
  RWANDA = "RWANDA",
  SAINT_BARTHELEMY = "SAINT_BARTHELEMY",
  SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA = "SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA",
  SAINT_KITTS_AND_NEVIS = "SAINT_KITTS_AND_NEVIS",
  SAINT_LUCIA = "SAINT_LUCIA",
  SAINT_MARTIN = "SAINT_MARTIN",
  SAINT_PIERRE_AND_MIQUELON = "SAINT_PIERRE_AND_MIQUELON",
  SAINT_VINCENT_AND_THE_GRENADINES = "SAINT_VINCENT_AND_THE_GRENADINES",
  SAMOA = "SAMOA",
  SAN_MARINO = "SAN_MARINO",
  SAO_TOME_AND_PRINCIPE = "SAO_TOME_AND_PRINCIPE",
  SAUDI_ARABIA = "SAUDI_ARABIA",
  SENEGAL = "SENEGAL",
  SERBIA = "SERBIA",
  SERBIA_AND_MONTENEGRO = "SERBIA_AND_MONTENEGRO",
  SEYCHELLES = "SEYCHELLES",
  SIERRA_LEONE = "SIERRA_LEONE",
  SIKKIM = "SIKKIM",
  SINGAPORE = "SINGAPORE",
  SINT_MAARTEN = "SINT_MAARTEN",
  SLOVAKIA = "SLOVAKIA",
  SLOVENIA = "SLOVENIA",
  SOLOMON_ISLANDS = "SOLOMON_ISLANDS",
  SOMALIA = "SOMALIA",
  SOUTHERN_RHODESIA = "SOUTHERN_RHODESIA",
  SOUTH_AFRICA = "SOUTH_AFRICA",
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS = "SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS",
  SOUTH_SUDAN = "SOUTH_SUDAN",
  SPAIN = "SPAIN",
  SRI_LANKA = "SRI_LANKA",
  SUDAN = "SUDAN",
  SURINAME = "SURINAME",
  SVALBARD_AND_JAN_MAYEN = "SVALBARD_AND_JAN_MAYEN",
  SWAZILAND = "SWAZILAND",
  SWEDEN = "SWEDEN",
  SWITZERLAND = "SWITZERLAND",
  SYRIAN_ARAB_REPUBLIC = "SYRIAN_ARAB_REPUBLIC",
  TAIWAN = "TAIWAN",
  TAJIKISTAN = "TAJIKISTAN",
  TANZANIA_UNITED_REPUBLIC_OF = "TANZANIA_UNITED_REPUBLIC_OF",
  THAILAND = "THAILAND",
  TIMOR_LESTE_DEMOCRATIC_REPUBLIC_OF = "TIMOR_LESTE_DEMOCRATIC_REPUBLIC_OF",
  TOGO = "TOGO",
  TOKELAU = "TOKELAU",
  TONGA = "TONGA",
  TRINIDAD_AND_TOBAGO = "TRINIDAD_AND_TOBAGO",
  TRISTAN_DE_CUNHA = "TRISTAN_DE_CUNHA",
  TUNISIA = "TUNISIA",
  TURKEY = "TURKEY",
  TURKMENISTAN = "TURKMENISTAN",
  TURKS_AND_CAICOS_ISLANDS = "TURKS_AND_CAICOS_ISLANDS",
  TUVALU = "TUVALU",
  UGANDA = "UGANDA",
  UKRAINE = "UKRAINE",
  UNITED_ARAB_EMIRATES = "UNITED_ARAB_EMIRATES",
  UNITED_KINGDOM = "UNITED_KINGDOM",
  UNITED_STATES = "UNITED_STATES",
  UNITED_STATES_MINOR_OUTLYING_ISLANDS = "UNITED_STATES_MINOR_OUTLYING_ISLANDS",
  UPPER_VOLTA = "UPPER_VOLTA",
  URUGUAY = "URUGUAY",
  USSR = "USSR",
  US_MISCELLANEOUS_PACIFIC_ISLANDS = "US_MISCELLANEOUS_PACIFIC_ISLANDS",
  UZBEKISTAN = "UZBEKISTAN",
  VANUATU = "VANUATU",
  VATICAN_CITY_STATE = "VATICAN_CITY_STATE",
  VENEZUELA_BOLIVARIAN_REPUBLIC_OF = "VENEZUELA_BOLIVARIAN_REPUBLIC_OF",
  VIET_NAM = "VIET_NAM",
  VIET_NAM_DEMOCRATIC_REPUBLIC_OF = "VIET_NAM_DEMOCRATIC_REPUBLIC_OF",
  VIRGIN_ISLANDS_BRITISH = "VIRGIN_ISLANDS_BRITISH",
  VIRGIN_ISLANDS_US = "VIRGIN_ISLANDS_US",
  WAKE_ISLAND = "WAKE_ISLAND",
  WALLIS_AND_FUTUNA = "WALLIS_AND_FUTUNA",
  WESTERN_SAHARA = "WESTERN_SAHARA",
  YEMEN = "YEMEN",
  YEMEN_DEMOCRATIC = "YEMEN_DEMOCRATIC",
  YUGOSLAVIA = "YUGOSLAVIA",
  ZAIRE = "ZAIRE",
  ZAMBIA = "ZAMBIA",
  ZIMBABWE = "ZIMBABWE",
}

export enum RepairProduct {
  MAINTENANCE = "MAINTENANCE",
  REPAIRS = "REPAIRS",
}

export enum SolarBillPeriod {
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
}

export enum SolarCalcPropertyType {
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  TOWNHOUSE = "TOWNHOUSE",
  UNIT = "UNIT",
}

export enum SolarContactTimePreference {
  AFTERNOON = "AFTERNOON",
  MORNING = "MORNING",
}

export enum SolarEnquiryType {
  MAINTENANCE = "MAINTENANCE",
  REPAIRS = "REPAIRS",
  UPGRADE = "UPGRADE",
}

export enum SolarPowerConnectionPhaseType {
  NOT_SURE = "NOT_SURE",
  SINGLE_PHASE = "SINGLE_PHASE",
  THREE_PHASE = "THREE_PHASE",
}

export enum SolarProduct {
  BATTERY = "BATTERY",
  SOLAR = "SOLAR",
  SOLAR_AND_BATTERY = "SOLAR_AND_BATTERY",
}

export enum SolarPropertyStorey {
  DOUBLE_STOREY = "DOUBLE_STOREY",
  MORE_THEN_THREE_STOREYS = "MORE_THEN_THREE_STOREYS",
  SINGLE_STOREY = "SINGLE_STOREY",
}

export enum SolarPropertyType {
  APARTMENT = "APARTMENT",
  HOUSE = "HOUSE",
  TOWNHOUSE = "TOWNHOUSE",
  UNIT = "UNIT",
}

export enum SolarRoofPitch {
  BOTH = "BOTH",
  FLAT = "FLAT",
  PITCHED = "PITCHED",
}

export enum SolarRoofType {
  ASBESTOS = "ASBESTOS",
  ASPHALT = "ASPHALT",
  CONCRETE_TILE = "CONCRETE_TILE",
  DECROMASTIC = "DECROMASTIC",
  EPDM = "EPDM",
  FIBRO = "FIBRO",
  FLAT_CONCRETE = "FLAT_CONCRETE",
  KLIPLOK = "KLIPLOK",
  SHINGLE = "SHINGLE",
  SLATE = "SLATE",
  TERRACOTTA_TILE = "TERRACOTTA_TILE",
  TIMBER = "TIMBER",
  TIN = "TIN",
  UNKNOWN = "UNKNOWN",
}

export interface AddressInput {
  level?: any | null;
  unit?: any | null;
  streetNumber?: any | null;
  streetName?: any | null;
  streetType?: any | null;
  postcode?: any | null;
  suburb?: any | null;
  state?: any | null;
  country?: Country | null;
}

export interface CalculatorValuesInput {
  postcode?: any | null;
  // houseStructure?: SolarCalcPropertyType | null;
  mostUsage?: any | null;
  bill?: number | null;
  systemSize?: any | null;
}

export interface CreateEnquiryInput {
  enquiryType: SolarEnquiryType;
  firstName: any;
  lastName: any;
  phone: any;
  email?: any | null;
  address?: AddressInput | null;
  comment?: any | null;
  allowMarketingCommunications: boolean;
  clientMutationId?: string | null;
}

export interface CreateLeadInput {
  productType: SolarProduct;
  firstName: any;
  lastName: any;
  phone: any;
  email?: any | null;
  address?: AddressInput | null;
  propertyType?: SolarPropertyType | null;
  roofType?: SolarRoofType | null;
  contactTimePreference?: SolarContactTimePreference | null;
  roofPitch?: SolarRoofPitch | null;
  averageQuarterlyBillCost?: number | null;
  usagePercentDuringDay?: any | null;
  propertyStorey?: SolarPropertyStorey | null;
  powerConnectionPhaseType?: SolarPowerConnectionPhaseType | null;
  allowMarketingCommunications: boolean;
  clientMutationId?: string | null;
  calculatorValues?: CalculatorValuesInput | null;
}

export interface RepairServiceabilityOptions {
  productType: RepairProduct;
  address: AddressInput;
}

export interface SolarRecommendationOptions {
  address: AddressInput;
  billCostForPeriod: number;
  billPeriod: SolarBillPeriod;
  usagePercentDuringDay: any;
}

export interface SolarServiceabilityOptions {
  productType: SolarProduct;
  address: AddressInput;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
